import * as React from 'react'
import type { SVGProps } from 'react'
function SvgLehrstellen216135437166(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 320.6 272.4"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M320.5,176L289.7,37.9c-0.3-1.3-1.3-2.3-2.6-2.6L144.7,0.1c-1.5-0.4-3.1,0.3-3.9,1.7c-0.8,1.4-0.5,3.1,0.6,4.2L187.4,52 C151.5,73.8,71,97.9,16.1,97.9c-4.4,0-8.5-0.2-12.3-0.4c-1.9-0.2-3.6,1.3-3.8,3.2c-0.1,1.9,1.3,3.6,3.2,3.8c4,0.3,8.4,0.5,12.9,0.5 c58.5,0,144.2-26.5,178.8-49.3c0.9-0.6,1.4-1.5,1.6-2.6c0.1-1-0.2-2.1-1-2.8L155.2,9.9l128.2,31.6l27.7,124.3l-40.7-40.7 c-0.8-0.8-1.8-1.1-2.8-1c-1,0.1-2,0.7-2.6,1.6c-15.4,23.4-32.1,69.2-41.5,113.9c-0.2,0.9,0,1.8,0.5,2.6c0.5,0.8,1.3,1.3,2.2,1.5 c0.2,0,0.5,0.1,0.7,0.1l0.3,0l0,0c1.5-0.1,2.8-1.3,3.1-2.8c8.7-41,24-84.2,38.2-107.9l46.1,46.1c1.1,1.1,2.8,1.4,4.2,0.6 C320.2,179.1,320.9,177.5,320.5,176z" />
        <path d="M205.8,217.1c-1.9,0-3.5,1.6-3.5,3.5v30.7c0,7.7-6.3,14-14,14H69.4c-7.7,0-14-6.3-14-14v-30.7c0-1.9-1.6-3.5-3.5-3.5 s-3.5,1.6-3.5,3.5v30.7c0,11.6,9.4,21,21,21h118.9c11.6,0,21-9.4,21-21v-30.7C209.3,218.7,207.7,217.1,205.8,217.1z" />
        <path d="M96.8,134.1L96.8,134.1c1.6,0,3-1.1,3.4-2.6c2.4-9.1,10.6-15.5,20-15.5h17.3c9.4,0,17.6,6.4,20,15.5c0.5,1.9,2.4,3,4.3,2.5 c0.9-0.2,1.7-0.8,2.1-1.6s0.6-1.7,0.4-2.7c-3.2-12.2-14.2-20.7-26.8-20.7h-17.3c-12.6,0-23.6,8.5-26.8,20.7 c-0.5,1.9,0.6,3.8,2.5,4.3C96.2,134.1,96.5,134.1,96.8,134.1z" />
        <path d="M204.8,148.2h-152c-8.3,0-15.1,6.8-15.1,15.1v24.7c0,8.3,6.8,15.1,15.1,15.1h152c8.3,0,15.1-6.8,15.1-15.1v-24.7 C219.9,154.9,213.1,148.2,204.8,148.2z M44.7,163.3c0-4.5,3.6-8.1,8.1-8.1h152c4.5,0,8.1,3.6,8.1,8.1v24.7c0,4.5-3.6,8.1-8.1,8.1 h-152c-4.5,0-8.1-3.6-8.1-8.1V163.3z" />
      </g>
    </svg>
  )
}
export default SvgLehrstellen216135437166
